/**
 * Universal slide meta fields — section, slug, title, meta-flag — shared
 * across every layout form.
 */

import type { Slide, SlideUpdatePayload } from "../types";
import { Checkbox, TextField } from "./FormPrimitives";

interface CommonSlideFieldsProps {
  draft: Slide;
  setField<K extends keyof SlideUpdatePayload>(
    key: K,
    value: SlideUpdatePayload[K],
  ): void;
  flush(): void;
}

export function CommonSlideFields({
  draft,
  setField,
  flush,
}: CommonSlideFieldsProps) {
  return (
    <div data-testid="common-slide-fields">
      <TextField
        label="Section header"
        value={draft.section}
        onChange={(v) => setField("section", v)}
        onBlur={flush}
        placeholder="II · DBM"
        testId="slide-section-input"
      />
      <TextField
        label="Slug"
        value={draft.slug}
        onChange={(v) => setField("slug", v)}
        onBlur={flush}
        mono
        testId="slide-slug-input"
      />
      <TextField
        label="Title HTML"
        value={draft.titleHtml}
        onChange={(v) => setField("titleHtml", v)}
        onBlur={flush}
        placeholder="Slide title"
        testId="slide-title-input"
      />
      <Checkbox
        label="Meta slide (collapsed in the slide rail)"
        checked={Boolean(draft.meta)}
        onChange={(v) => setField("meta", v)}
        onBlur={flush}
        testId="slide-meta-checkbox"
      />
    </div>
  );
}
